import { render, staticRenderFns } from "./WorkBookQuestionsOpenCustomTopEntry.vue?vue&type=template&id=dbe82fd4&scoped=true&"
import script from "./WorkBookQuestionsOpenCustomTopEntry.vue?vue&type=script&lang=js&"
export * from "./WorkBookQuestionsOpenCustomTopEntry.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookQuestionsOpenCustomTopEntry.vue?vue&type=style&index=0&id=dbe82fd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe82fd4",
  null
  
)

export default component.exports